import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getLocatorIconsEnabled = (configuration: IConfigurationParams[]): boolean => {
  const locatorIconsParams = configuration.find((
    params,
  ) => params.name === ConfigurationNames.locatorIcons);

  return locatorIconsParams ? JSON.parse(locatorIconsParams.configuration).enabled : false;
};
